import {
  IAfterGuiAttachedParams,
  IDoesFilterPassParams,
} from 'ag-grid-community';
import { CustomFilterProps, useGridFilter } from 'ag-grid-react';
import React, { useCallback, useRef } from 'react';
import { filterStyles } from './styles';
import { arrayContainsSubstring, getProductProperties } from './helpers';

export default ({ model, onModelChange, colDef }: CustomFilterProps) => {
  const refInput = useRef<HTMLInputElement>(null);

  const doesFilterPass = useCallback(
    (params: IDoesFilterPassParams) => {
      const filterText: string = model;
      if (colDef.field !== 'title') {
        const rowValue =
          params.data[
            getProductProperties(params.data.product, colDef.field as string)
          ];
        if (Array.isArray(rowValue)) {
          return arrayContainsSubstring(rowValue, filterText);
        } else if (typeof rowValue === 'string') {
          return rowValue.includes(filterText);
        } else {
          return false;
        }
      } else {
        const rowValue = params.data[colDef.field as string];
        if (rowValue.toLowerCase().includes(filterText.toLowerCase())) {
          return true;
        } else {
          return false;
        }
      }
    },
    [model]
  );

  const afterGuiAttached = useCallback((params?: IAfterGuiAttachedParams) => {
    if (!params || !params.suppressFocus) {
      refInput.current?.focus();
    }
  }, []);

  // register filter handlers with the grid
  useGridFilter({
    doesFilterPass,
    afterGuiAttached,
  });
  return (
    <div style={filterStyles.container}>
      <div>
        <input
          ref={refInput}
          type='text'
          style={filterStyles.input}
          value={model || ''}
          onChange={({ target: { value } }) =>
            onModelChange(value === '' ? null : value)
          }
          placeholder='Search...'
        />
      </div>
    </div>
  );
};
